import React from 'react';

const JS_Cookies = () => {
  return (
    <div >
      <h1>JS_Cookies</h1>
      <p>Placeholder component for: "JS Cookies"</p>
    </div>
  );
};

export default JS_Cookies;
